<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>Copyright &copy; {{ new Date().getFullYear() }} </span>
          <a href="https://espressolabs.com.br" target="_blank" rel="nofollow">Espresso Labs</a>
        </p>
        <span class="md:flex hidden items-center">
          <span>Desenvolvido pela&nbsp;</span>
          <a href="https://espressolabs.com.br" target="_blank" rel="nofollow">Espresso Labs</a>
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
